import GinStepHeader from '@hellodarwin/app-features/lib/features/gin-steps/common-components/gin-step-header';
import GinStepItemList from '@hellodarwin/app-features/lib/features/gin-steps/common-components/gin-step-item/gin-step-item-list';
import Collapse from '@hellodarwin/core/lib/components/common/Collapse';
import {
  getGinStepAssignedContactIds,
  GinStep,
} from '@hellodarwin/core/lib/features/entities/gin-step-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useTheme } from 'styled-components';
import { useAppSelector } from '../../../../../app/index';
import {
  SelectCompanyUserById,
  selectProfile,
} from '../../../../../features/api/slices/profile-slice';

interface GinStepStepsProps {
  currentStep: GinStep;
  isActive: boolean;
  onToggle: () => void;
}

const GinStepSteps = ({
  currentStep,
  isActive,
  onToggle,
}: GinStepStepsProps) => {
  const { t } = useTranslations();
  const theme = useTheme();

  const contacts = useAppSelector((state) =>
    getGinStepAssignedContactIds(currentStep)
      .map((contactId) => SelectCompanyUserById(state, contactId))
      .filter((contact): contact is NonNullable<typeof contact> => !!contact),
  );

  const profile = useAppSelector(selectProfile);
  const stepElementId = `step-${currentStep.page_order}`;

  return (
    <Collapse
      noPadding
      activeKey={isActive ? [stepElementId] : []}
      onChange={onToggle}
      items={[
        {
          id: stepElementId,
          styles: {
            container: {
              border: `1px solid ${theme.colors.grey_4}`,
            },
            header: {
              backgroundColor: theme.colors.beige_2,
              padding: '8px 16px',
              gap: 16,
            },
          },
          title: (
            <GinStepHeader
              stepElementId={stepElementId}
              step={currentStep}
              pageId={currentStep.page_id}
              formFillingStepState={{
                isStepActive: currentStep.is_active ?? false,
                isStepCompleted: !!currentStep.completed_at,
                contact: contacts[0],
                contacts,
              }}
              stepNumberText={
                t('gin_steps|step') + ' ' + currentStep.page_order
              }
              activeContactId={profile.contact_id}
            />
          ),
          children: <GinStepItemList stepId={currentStep.step_id} />,
        },
      ]}
      ExpandIcon={({ isActive }) => <TabArrow size={20} down={isActive} />}
    />
  );
};

export default GinStepSteps;
